<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 479.056 479.056"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M239.516 382.289L36.347 165.318c11.984-10.256 24.736-19.303 37.902-27.565L52.525 116.03c-16.809 11.025-32.869 23.43-47.801 37.461-6.023 5.658-6.33 15.117-.673 21.14L228.61 414.437a14.935 14.935 0 0 0 10.921 4.737h.015c4.137 0 8.099-1.725 10.936-4.751l48.486-51.951-21.188-21.188-38.264 41.005zM479.045 163.081a14.996 14.996 0 0 0-4.737-10.438c-64.107-59.824-147.483-92.762-234.777-92.762-45.632 0-89.946 9.812-131.277 27.2L51.112 29.94 29.943 51.109 427.95 449.116l21.169-21.169-109.275-109.275L475.04 173.813a14.96 14.96 0 0 0 4.006-10.731zM318.656 297.483L131.208 110.035c34.431-12.916 70.889-20.214 108.323-20.214 74.692 0 146.27 26.432 203.155 74.75z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>